import React from 'react'
import theme from 'config/theme'
import { StyledProgressBar } from 'components/ProgressBar/styled'

export default function ProgressBar({ marginRight, width, progress }) {
	return (<>
		<StyledProgressBar width={width} progress={progress} marginRight={marginRight} theme={ theme }>
			<div className='progress'/>
		</StyledProgressBar>
	</>)
}
